<template>
  <div class="emergency-trainings-container">
    <VueText style="margin: 30px 0 0;" sizeLevel="8" weightLevel="2" class="text">
      Afetlere Hazır Olmak</VueText
    >
    <div class="emergency-trainings-list">
      <div
        v-for="(item, index) in videoUrlList"
        v-html="item.url"
        :id="`emergency-video-${index}`"
        :key="index"
        class="emergency-trainings-item"
      />
    </div>
  </div>
</template>
<script>
import VueText from '@/components/shared/VueText/VueText.vue';
import { Common } from '@/services/Api/index';

export default {
  name: 'EmergencyTrainings',
  components: { VueText },
  data() {
    return {
      videoUrlList: [],
    };
  },
  mounted() {
    this.getEmergencyTrainings();
  },
  methods: {
    getEmergencyTrainings() {
      Common.getEmergencyTrainings().then(res => {
        const {
          Data: { videoUrlList },
        } = res.data;
        this.videoUrlList = videoUrlList;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.emergency-trainings {
  &-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  &-list {
    display: flex;
    flex-wrap: wrap;
  }
  &-item {
    max-width: 23% !important;
    margin: 30px 10px !important;
  }
}
</style>
